import {useContext} from 'react'
import { NavLink,Link } from 'react-router-dom'
import "./Navbar.css"
import logo from "../img/loghi/logo.png"
import {Account} from "../Main"

const Navbar = () => {
    const utente_user = useContext(Account);

    return (
        <div id="navbar">
            <div className='logo'>
                <Link to=""><img src={logo} alt="logo"/></Link>
                <h1>Sporting Club Saluzzo</h1>
            </div>
            <div id="links">
                <NavLink to="/">
                    <i className="fa-solid fa-home"></i>
                    <span>Home</span>
                </NavLink>
                <NavLink to="/prenota">
                    <i className="fa-solid fa-calendar"></i>
                    <span>Prenota</span>
                </NavLink>
                <NavLink to="/classifica-mobile" id="link_classifica" 
                    className={({ isActive }) =>
                        `
                        ${isActive ? "active" : ""}
                        ${utente_user.persona.sfide_presenti ? "sfide-presenti" : ""}
                        `
                    }>
                    <i className="fa-solid fa-ranking-star"></i>
                    <span id="user-nav">Classifica</span>
                </NavLink>
                <NavLink to={utente_user.persona.nome ? "/profilo" : "/login"} id="link_accedi">
                    <i className="fa-solid fa-user"></i>
                    <span id="user-nav">{utente_user.persona.nome !== "" ? utente_user.persona.nome : "Accedi"}</span>
                </NavLink>
                {
                    utente_user.persona.maestro === true && (utente_user.persona.username === 'maestro') ?
                    <NavLink to="/gestione" id="link_gestione">
                        <i className="fa-solid fa-screwdriver-wrench"></i>
                        <span id="user-nav">Utenti</span>
                    </NavLink>
                    : null
                }
            </div>
        </div>
    )
}

export default Navbar